/**
 * Derived free sample cart state — single source of truth for drawer, line prices, progress bar.
 * Only lines added from the cart drawer (_sample_gift property) can be free.
 * At most one unit per gift line is free.
 */
(function () {
  function getLinePriceCents(item) {
    if (!item) return 0;
    return item.final_line_price != null ? item.final_line_price : item.line_price || 0;
  }

  function getLineUnitPriceCents(item) {
    const linePrice = getLinePriceCents(item);
    const qty = item?.quantity || 1;
    if (qty <= 1) return linePrice;
    return Math.round(linePrice / qty);
  }

  function getLineKey(item) {
    if (!item) return '';
    if (item.key) return String(item.key);
    if (item.variant_id != null) return String(item.variant_id);
    return String(item.id || '');
  }

  function isGiftLine(item) {
    return Boolean(item?.properties?._sample_gift);
  }

  function getGiftLinePaidContribution(item) {
    const qty = item?.quantity || 1;
    if (qty <= 1) return 0;
    const unitPrice = getLineUnitPriceCents(item);
    return unitPrice * (qty - 1);
  }

  function getPaidSubtotalCents(items) {
    return items.reduce((sum, item) => {
      if (isGiftLine(item)) return sum + getGiftLinePaidContribution(item);
      return sum + getLinePriceCents(item);
    }, 0);
  }

  function getFreeSampleState(cart, options = {}) {
    const threshold = Number(options.thresholdCents) || 12000;
    const items = cart?.items ?? [];
    const paidSubtotal = getPaidSubtotalCents(items);
    const isThresholdReached = paidSubtotal >= threshold;

    const giftLines = items.filter(isGiftLine);

    let freeLineKey = null;
    let freeLinePriceCents = 0;

    if (giftLines.length > 0 && isThresholdReached) {
      const giftLine = giftLines[0];
      freeLineKey = getLineKey(giftLine);
      freeLinePriceCents = getLineUnitPriceCents(giftLine);
    }

    const freeApplied = Boolean(freeLineKey);
    const canAddFreeSample = isThresholdReached && giftLines.length === 0;
    const shouldShowCarousel = canAddFreeSample;
    const shouldDisableCarousel = !isThresholdReached;
    const displaySubtotal = paidSubtotal;
    const shouldShowChange = freeApplied;

    return {
      paidSubtotal,
      displaySubtotal,
      threshold,
      isThresholdReached,
      freeLineKey,
      freeLinePriceCents,
      freeApplied,
      freeFromDrawer: freeApplied,
      canAddFreeSample,
      shouldShowCarousel,
      shouldDisableCarousel,
      shouldShowConfirmation: false,
      shouldShowChange,
      giftLineCount: giftLines.length,
      isLineFree(item) {
        if (!isThresholdReached || !item) return false;
        return isGiftLine(item) && (item.quantity || 1) === 1;
      }
    };
  }

  window.HugyFreeSampleState = {
    getLinePriceCents,
    getLineUnitPriceCents,
    getLineKey,
    isGiftLine,
    getGiftLinePaidContribution,
    getPaidSubtotalCents,
    getFreeSampleState
  };
})();
